import React from 'react';
import { Switch, SwitchProps } from 'antd';

export type AsyncSwitchProps = SwitchProps;

export const AsyncSwitch: React.FC<AsyncSwitchProps> = ({
  onChange,
  ...props
}) => {
  const [loading, setLoading] = React.useState(false);

  return (
    <Switch
      {...props}
      loading={loading}
      onChange={async (...args) => {
        if (!onChange) {
          return false;
        }

        setLoading(true);

        try {
          await onChange(...args);
        } finally {
          setLoading(false);
        }
      }}
    />
  );
};
